module.exports = "<app-welcome (next)=\"onNext()\" (cancel)=\"onCancel()\"></app-welcome>";